import Offcanvas, { OffcanvasProps } from 'react-bootstrap/Offcanvas';
import { IDrawerStyles, useDrawerStyles } from './';
import { DrawerBody, DrawerFooter, DrawerForm, DrawerHeader, DrawerStyled, DrawerTitle, DrawerView } from './components';

export interface DrawerProps extends OffcanvasProps {
    controlStyles?: IDrawerStyles | undefined;
}

const ComponentProps = (props: DrawerProps): OffcanvasProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;

    return componentProps;
}

const Drawer: React.FC<DrawerProps> = (props) => {
    const styles: IDrawerStyles = props.controlStyles ?? useDrawerStyles();

       return (
           <Offcanvas {...ComponentProps(props)} style={{ ...styles.container, ...props.style }} />
    );
};

export default Object.assign(Drawer, {
    Body: DrawerBody,
    Footer: DrawerFooter,
    Form: DrawerForm,
    Header: DrawerHeader,
    Styled: DrawerStyled,
    Title: DrawerTitle,
    View: DrawerView
});